import { gql } from '@apollo/client'

export const connectTwitter = gql`
  mutation ConnectTwitter($code: String!, $verifier: String!, $secret: String!) {
    connectTwitter(code: $code, verifier: $verifier, secret: $secret)
  }
`
